import { render, staticRenderFns } from "./PrevIcon.vue?vue&type=template&id=5f3b8c52&scoped=true"
import script from "./PrevIcon.vue?vue&type=script&lang=js"
export * from "./PrevIcon.vue?vue&type=script&lang=js"
import style0 from "./PrevIcon.vue?vue&type=style&index=0&id=5f3b8c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b8c52",
  null
  
)

export default component.exports